export default {"src":"/_next/static/media/arrow-alternate-icon.c5186e14.svg","height":12,"width":12};